module.exports = __webpack_public_path__ + "static/OpenSans-Bold-f5331cb6372b6c0d8baf2dd7e200498c.ttf";